export default __webpack_public_path__ + "static/media/Ficha_garbanzo_EN.e4b9b9d7.png";